import React from "react";
import noop from "lodash/noop";
import SvgIcon from "./SvgIcon";
import cx from "classnames";
import BackButton from "./BackButton";

function Modal({
  children,
  toClear = [],
  onClose = noop,
  canClose = true,
  backButton = false,
  forwardButton = false,
  goBack = noop,
  goForward = noop,
  title,
  className,
  header = true,
}) {
  const toClearString = Array.isArray(toClear)
    ? toClear.join("=&")
    : toClear
    ? [toClear].join("=&")
    : "";

  const closeHref = toClearString
    ? `/actions/refresh?modal=&${toClearString}=`
    : "/actions/refresh?modal=";

  return (
    <div role="modal" className={cx("Modal-Box", className)}>
      <a href={closeHref} onClick={onClose} className="overlay" />

      <div className="box">
        {header && (
          <header>
            <div className="modal-back-container">
              {backButton && (
                <BackButton />
                // <button className="modal-nav-btn modal-back" onClick={goBack}>
                //   <img
                //     className="modal-nav-icon"
                //     src="/img/svg/angle-left.svg"
                //     alt="next"
                //   />
                // </button>
              )}
              <h2 className="capitalize">{title}</h2>
            </div>

            {canClose && (
              <a
                href={closeHref}
                onClick={onClose}
                // className="close"
                role="button"
                data-button-type="tertiary"
                data-icon-only="true"
              >
                <img src="/img/new-icons/red-cross.svg" alt="dismiss" />
              </a>
            )}
          </header>
        )}
        {children}
      </div>
      {forwardButton && (
        <div className="modal-nav-btn modal-forward" onClick={goForward}>
          <img
            className="modal-nav-icon"
            src="/img/svg/angle-right.svg"
            alt="next"
          />
        </div>
      )}
    </div>
  );
}

export default Modal;
